<script setup>
/**
 * OCHAT: el estado de una reserva, con color.
 *
 * Retenida va en ámbar y no en verde a propósito: es la que puede desaparecer sola
 * cuando venza, y el equipo tiene que poder distinguirla de una confirmada de un
 * pantallazo.
 */
import { computed } from 'vue';

const props = defineProps({
  status: { type: String, required: true },
});

const STYLES = {
  held: 'bg-n-amber-3 text-n-amber-11',
  confirmed: 'bg-n-teal-3 text-n-teal-11',
  checked_in: 'bg-n-teal-3 text-n-teal-11',
  checked_out: 'bg-n-slate-3 text-n-slate-11',
  cancelled: 'bg-n-slate-3 text-n-slate-11',
  no_show: 'bg-n-ruby-3 text-n-ruby-11',
};

const classes = computed(() => STYLES[props.status] ?? STYLES.checked_out);
const label = computed(() => `BOOKINGS.STATUS.${props.status.toUpperCase()}`);
</script>

<template>
  <span
    class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md"
    :class="classes"
  >
    {{ $t(label) }}
  </span>
</template>
